<template>
    <div class="hub-biodata">
        <b-card no-body v-if="current_hub">
            <b-card-header class="border-0 p-3">
                <b-row align-v="center">
                    <b-col cols="10">
                        <h3 class="mb-0">
                            {{ current_hub.hub_name }}
                        </h3>
                    </b-col>
                    <b-col cols="2">
                        <b-link @click="$refs.drawer_hub_team_details.viewHubTeamDetails()" class="float-right py-0 text-primary">Edit</b-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="pb-2">
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex align-items-center mb-2">
                            <b class="pr-3 text-gray">ID</b>
                            <p class="mb-0">{{ current_hub.hub_id }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="mr-3"><g fill="none" stroke="#A4B0C0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M11 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0"/><path d="M12 7a5 5 0 1 0 5 5"/><path d="M13 3.055A9 9 0 1 0 20.941 11"/><path d="M15 6v3h3l3-3h-3V3zm0 3-3 3"/></g></svg>
                            <p class="mb-0">RM{{ current_hub.total_target | moneyFormatter }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="mr-3"><path fill="#A4B0C0" d="M14.75 15c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297-2.91 0-4.567-1.09-4.567-3.259v-1c0-.966.784-1.75 1.75-1.75h5.5Zm-11-5h4.376a4.007 4.007 0 0 0 1.067 3.85l.162.151L9.25 14a2.75 2.75 0 0 0-2.649 2.008l-.034.001C3.657 16.009 2 14.919 2 12.75v-1c0-.966.784-1.75 1.75-1.75Zm16.5 0c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297l-.169-.002a2.756 2.756 0 0 0-2.451-2L14.75 14l-.105.001a3.99 3.99 0 0 0 1.229-4L20.25 10ZM12 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6.5 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm11 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/></svg>
                            <p class="mb-0">{{ current_hub.team_counts }} teams</p>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <h5 class="font-weight-500 text-dark mb-0">Team's Performance</h5>
                    </b-col>
                </b-row>
                <b-row class="team-performance text-muted">
                    <b-col cols="1" class="px-1 py-2 text-center"><span>#</span></b-col>
                    <b-col cols="4" class="px-1 py-2">Team</b-col>
                    <b-col cols="5" class="px-1 py-2">Pre-Rev./KPI(RM)</b-col>
                    <b-col cols="2" class="px-1 py-2">Act. RP</b-col>
                </b-row>
                <div v-for="(team, index) in current_hub.hub_teams" :key="index">
                    <b-row class="team-performance border rounded mb-2" @click="teamDetails(team.hub_team_id)">
                        <b-col cols="1" class="px-1 py-2 text-center align-self-center">{{ index + 1}}</b-col>
                        <b-col cols="4" class="px-1 py-2 align-self-center">
                            <p class="mb-0 text-primary font-weight-500">{{ team.hub_team_name }}</p>
                            <span class="text-muted text-xs">{{ team.team_members_counts }} members</span>
                        </b-col>
                        <b-col cols="5" class="px-1 py-2 align-self-center">
                            <span class="pb-1">{{ team.team_total_revenue_point | moneyFormatter }} ({{ (team.team_total_revenue_point / team.teams_kpi_achievement_amount * 100) | moneyFormatter}}%)<span class="text-muted"> / {{ team.teams_kpi_achievement_amount | moneyFormatter }}</span></span>
                            <b-progress height="7px" :value="team.team_total_revenue_point / team.teams_kpi_achievement_amount * 100" :max="100.00" class="w-75" variant="success"></b-progress>
                        </b-col>
                        <b-col cols="2" class="px-1 py-2 align-self-center">
                            RM
                            {{team.team_actual_total_revenue_point | moneyFormatter}}
                        </b-col>
                    </b-row>
                </div>
            </b-container>
        </b-card>

        <!-- Drawer for Hub Team Details -->
        <drawer-hub-team-details ref="drawer_hub_team_details"></drawer-hub-team-details>
    </div>
</template>
<script>
import DrawerHubTeamDetails from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubTeamDetails'
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'

export default {
    components: {
        DrawerHubTeamDetails,
    },
    computed: {
        ...mapState(useHubStore,['current_hub'])
    },
    methods: {
        ...mapActions(useHubStore,['getHubTeams']),
        async teamDetails(id) {
            if (this.$route.path !== '/teamProfileDetails/') {
                await this.getHubTeams(id) 
                this.$router.push('/teamProfileDetails/' + id) 
            }
        }
    }
}
</script>